/* *@description: 批量上传组件 */
<template>
  <div>
    <div class="img_box">
      <div
        class="img_size"
        v-for="(item, index) of fileListResAll"
        :key="index"
        v-show="fileListResAll.length !== 0"
      >
        <!-- <div>{{ item }}</div> -->
        <!-- 图片预览 -->
        <!-- <img
          v-if="getFileTypeIcon(item) === 'hidden'"
          :src="item.downloadUrl"
        /> -->
        <el-image
          v-if="getFileTypeIcon(item) === 'hidden'"
          :src="item.downloadUrl"
          :preview-src-list="[item.downloadUrl]"
          class="image"
        />
        <span v-if="getFileTypeIcon(item) !== 'hidden'">
          <i :class="'iconfont icon_size ' + getFileTypeIcon(item)" />
        </span>
        <!-- 删除 -->
        <span
          class="close"
          @click="fileDel(index, option.fileNames)"
          v-if="!isView"
        >
          <el-icon class="delete"><Close /></el-icon>
        </span>
        <div class="img-mark" v-if="getFileTypeIcon(item) !== 'hidden'">
          <span
            v-if="getFileTypeIcon(item) === 'hidden'"
            @click="showImg(index)"
          >
            <el-icon><Search /></el-icon>
          </span>
          <span
            v-if="getFileTypeIcon(item) !== 'hidden'"
            @click="handleDownload(item)"
          >
            <i class="iconfont iconcaozuopingtaitubiao_daojiancaozuo" />
          </span>
        </div>
      </div>
      <!-- 上传 -->
      <div
        class="add_img"
        v-show="currentLimit !== limit"
        @click="fileClick"
        v-if="!isView"
        v-loading="loading"
      >
        <el-icon><Plus /></el-icon>
      </div>
      <!-- 上传按钮 -->
      <input
        :id="option.fileNames"
        name="files"
        style="display: none"
        @change="fileChange($event)"
        type="file"
        ref="file"
        :multiple="multiple"
        :accept="nameTransformation(fileTypeList)"
      />
    </div>
  </div>
</template>

<script setup name="BatchUpload">
import { $t } from '@/plugins/i18n';
import request from '@/utils/request';
import axios from 'axios';
import { GATEWAY } from '@/utils/const';
import { cloneDeep } from 'lodash-es';
import {
  reactive,
  toRefs,
  watch,
  defineProps,
  defineEmits,
  getCurrentInstance
} from 'vue';
import { ElMessage } from 'element-plus';
const { proxy, ctx } = getCurrentInstance();
// 文件上传组件可选文件格式
const typeArr = {
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  doc: 'application/msword',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'x-zip-compressed':
    'application/zip,application/x-zip,application/x-zip-compressed',
  pdf: 'application/pdf',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  gif: 'image/gif',
  png: 'image/png'
};
const data = reactive({
  imgList: [],
  fileListResAll: [], // 传递的时的数据
  currentLimit: 0, // 当前数量
  urlList: [],
  loading: false
});

const props = defineProps({
  //子组件接收父组件传递过来的值
  // 配置项
  option: {
    type: Object,
    default() {
      return {
        projectName: '',
        moduleName: '',
        fileNames: ''
      };
    }
  },
  // 数据
  list: {
    type: Array,
    default: () => []
  },
  // 文件大小
  fileSize: {
    type: Number,
    default: () => 5
  },
  // 最大允许上传个数
  limit: {
    type: Number,
    default: () => 3
  },
  // 上传前回调
  beforeUpload: {
    type: Function,
    default: () => {}
  },
  // 允许上传的文件类型
  fileTypeList: {
    type: Array,
    default: () => ['png', 'pdf', 'jpg', 'jpeg', 'x-zip-compressed']
  },
  // 是否允许批量上传
  multiple: {
    type: Boolean,
    default: () => false
  },
  // 是否详情
  isView: {
    type: Boolean,
    default: () => false
  }
});
const { imgList, fileListResAll, currentLimit, urlList, loading } =
  toRefs(data);

const { option, list, fileSize, limit, fileTypeList, multiple, isView } =
  toRefs(props);

const emit = defineEmits(['uploadSuccess', 'uploadRemove']);

watch(
  list,
  newVal => {
    fileListResAll.value = newVal;
    currentLimit.value = fileListResAll.value.length;
    urlList.value = fileListResAll.value.map(item => item.downloadUrl);
  },
  { immediate: true, deep: true }
);

/**
 * 后缀校验转换
 * @param {*} list
 */
function nameTransformation(list) {
  const newType = cloneDeep(list);
  for (const key in typeArr) {
    const val = newType.indexOf(key);
    val !== -1 && (newType[val] = typeArr[key]);
  }
  return newType.join(',');
}
/**
 * 判断文件类型ICON
 * @param {*} item 行数据
 */
function getFileTypeIcon(item) {
  const { path, downloadUrl } = item;
  const name = path || downloadUrl;
  if (name.indexOf('.pdf') > -1) {
    return 'iconPDF';
  }
  if (name.indexOf('.docx') > -1) {
    return 'icondocx1';
  }
  if (name.indexOf('.doc') > -1) {
    return 'icondoc1';
  }
  if (name.indexOf('.xls') > -1 || name.indexOf('.xlsx') > -1) {
    return 'icongonggaoguanli-wendang';
  }
  if (name.indexOf('.zip') > -1) {
    return 'iconyasuobao';
  }
  if (name.indexOf('.rar') > -1) {
    return 'iconRAR';
  }
  if (name.indexOf('.ppt') > -1 || name.indexOf('.pptx') > -1) {
    return 'iconteshu-wendang';
  }
  return 'hidden';
}
/**
 * 上传点击事件
 * @param {*} null
 */
function fileClick() {
  document.getElementById(option.value.fileNames).click();
}
/**
 * 上传监听事件
 * @param {*} el DOM数据
 */
function fileChange(el) {
  // 1.上传前回调
  // if (beforeUpload.value && typeof beforeUpload.value === 'function') {
  //   beforeUpload.value();
  // }
  if (!el.target.files[0].size) return;
  fileList(el.target);
  el.target.value = '';
}
function handleDownload(file) {
  window.open(file.downloadUrl, file.name);
}
/**
 * 文件处理中转
 * @param {*} fileList
 */
async function fileList(fileList) {
  const files = fileList.files;
  for (let i = 0; i < files.length; i++) {
    // 1. 校验文件规格
    if (verifyFun(files[i])) {
      // 2.1 数量增加
      currentLimit.value++;
      // 2.2 非文件夹处理
      if (files[i].type !== '') {
        fileAdd(files[i]);
        uploadFile(files[i]);
      }
    } else {
      break;
    }
  }
}
/**
 * 生成随机文件名称
 * 时间戳 + （0， 1000之间随机数）+ 后缀
 */
function getRandomFileName(name) {
  // 处理文件名多余非法字符
  const filterName = name
    .substring(0, name.lastIndexOf('.'))
    .replace(
      /[\ |\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?/\，/\。/\；/\：/\“/\”/\》/\《/\|/\{/\}/\、/\!/\~/\`]/g,
      ''
    );
  const suffixName = name.substring(name.lastIndexOf('.'));
  const rdNumber1000 = Math.floor(Math.random() * 1000) + 1;
  return filterName + new Date().getTime() + rdNumber1000 + suffixName; // 文件名称 随机化
}
/**
 * 获取阿里云路径
 * @param {*} null
 */
async function uploadFile(file) {
  // 1. 请求阿里云接口,获得阿里云上传路径/密钥以及签名
  const name = file.name;
  // 处理文件名多余非法字符
  const filename = getRandomFileName(name);
  const params = {
    ...option.value,
    filename,
    size: file.size
  };
  const { code, data } = await request({
    url: `${GATEWAY.CJS}/file/oss/getUploadUrl`,
    method: 'get',
    params
  });
  // 2. 异常报错
  if ((!code && code !== 1) || !data) {
    ElMessage({
      message: $t('文件上传功能异常，请联系客服'),
      type: 'error'
    });
    return;
  }
  // 3 处理阿里云上传路径
  const { 'content-type': contentType, url, key: path } = data;
  const res = {
    path,
    contentType,
    url,
    config: { headers: { 'Content-Type': contentType } }
  };
  // 4. PUT阿里云方法
  httpRequest(res, file);
}
/**
 * 阿里云上传接口
 * @param {*} list 阿里云地址数据
 */
async function httpRequest(list, file) {
  loading.value = true;
  const resData = await axios.put(list.url, file, list.config);
  loading.value = false;
  if ((resData || {}).status === 200 || (resData || {}).status === 201) {
    fileListResAll.value.push(Object.assign(list, file));
    if (fileListResAll.value.length + 1 === currentLimit.value) {
      ElMessage({
        message: $t('上传成功'),
        type: 'success'
      });
    }
  }
  const obj = {};
  obj.key = option.value.fileNames;
  obj.res = Object.assign({}, Object.assign(list, file));
  obj.fileList = fileListResAll.value;
  // 2. 响应数据
  emit('uploadSuccess', obj);
}
/**
 * 文件校验方法
 * @param {*} file 文件地址
 */
function verifyFun(file) {
  // 1. 文件类型
  const [type] = file.name.split('.').slice(-1);
  // 1.1 判断文件类型可上传性
  const isRtTy =
    !fileTypeList.value.length || fileTypeList.value.includes(type);
  // 2. 文件大小
  const isLtRuleSize = file.size / 1024 / 1024 < fileSize.value;
  // 2.1 判断文件大小
  if (!isLtRuleSize) {
    ElMessage({
      message: `${$t('上传大小不能超过')} ${fileSize.value} MB!`,
      type: 'error'
    });
    return false;
  }

  // 2.2 上传数量限制 Ps:没什么用了,已做accept限制,此处二次限制而已
  if (currentLimit.value >= limit.value) {
    ElMessage({
      message: `${$t('最多只能上传')} ${limit.value} ${$t('个文件')}`,
      type: 'warning'
    });
    return false;
  }
  // 2.3 判断文件类型
  if (!isRtTy) {
    ElMessage({
      message: `${$t('只能上传')} ${fileTypeList.value.join(' ')} ${$t(
        '格式'
      )}`,
      type: 'warning'
    });

    return false;
  }
  // 3. 校验通过
  return true;
}
/**
 * 储存文件
 * @param {*} file 文件地址
 */
function fileAdd(file) {
  const reader = new FileReader();
  reader.vue = this;
  reader.readAsDataURL(file);
  reader.onload = function () {
    file.downloadUrl = this.result;
    imgList.value = file;
  };
}
/**
 * 删除方法
 * @param {*} index 当前索引
 */
function fileDel(index) {
  fileListResAll.value.splice(index, 1);
  currentLimit.value--;
  emit('uploadRemove', {
    uploadKey: option.value.fileNames,
    fileList: fileListResAll.value
  });
}
/**
 * 预览
 * @param {*} index 当前索引
 */
function showImg() {
  urlList.value = fileListResAll.value.map(item => item.downloadUrl);
  // $openImagePreview(urlList, imgIndx);
}
// function unmounted() {
//   fileListResAll.value = [];
// }
</script>

<style scoped lang="scss">
@mixin upload($type) {
  @each $themename, $theme in $themes {
    [data-theme='#{$themename}'] & {
      @if $type == border {
        border: 1px
          map-get($map: $theme, $key: upload-border-type)
          map-get($map: $theme, $key: upload-border-color);
      } @else if $type == addBg {
        background: map-get($map: $theme, $key: upload-add-bg);
      } @else if $type == rightHover {
        background: map-get($map: $theme, $key: upload-right-hover);
      } @else if $type == rightBorder {
        border: 1px solid map-get($map: $theme, $key: upload-border-color);
      } @else if $type == rightCloseBg {
        background: map-get($map: $theme, $key: upload-right-close-bg);
      } @else if $type == fileBg {
        color: map-get($map: $theme, $key: upload-img-fileBg);
      }
    }
  }
}
.img_box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .img_size {
    position: relative;
    width: 100px;
    height: 100px;
    border: 1px solid #ddd;
    border-radius: 5px;
    margin-top: 5px;
    margin-right: 10px;
    &:hover {
      .img-mark {
        visibility: visible !important;
      }
    }
    .img-mark {
      position: absolute;
      visibility: hidden;
      width: 100px;
      height: 28px;
      bottom: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.5);
      cursor: pointer;
      color: #ffffff;
    }
    img {
      width: 100%;
      height: 100%;
    }
    .image {
      width: 100%;
      height: 100%;
    }
  }
  .add_img {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 100px;
    margin-top: 5px;
    font-size: 18px;
    cursor: pointer;
    font-weight: 600;
    color: #777777;
    border: 1px solid #ddd;
    border-radius: 5px;
  }
  .img_size {
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
  }
  .icon_size {
    font-size: 30px;
  }
  .close {
    height: 10px;
    width: 10px;
    right: -3px;
    position: absolute;
    top: -7px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .delete {
      height: 14px;
      width: 14px;
      background-color: #61666d;
      border-radius: 14px;
    }
  }
}
</style>
